import { Grid } from '@chipinside/frontend'
import { Button } from '@mui/material'
import Collapse from '@mui/material/Collapse'

import { Icon } from '#/components/Icon'

export function FormBuilderCollapse(props: any) {
  const { children, expanded, label, name, setExpanded } = props

  return (
    <>
      <Button
        id={name}
        onClick={() => setExpanded(prevState => !prevState)}
        endIcon={
          expanded ? <Icon name="chevron-up" size={20} /> : <Icon name="chevron-down" size={20} />
        }
        sx={{ width: '100%' }}
      >
        {label}
      </Button>
      <Collapse in={expanded} timeout="auto">
        <Grid container spacing={2} sx={{ mt: 2 }}>
          {children}
        </Grid>
      </Collapse>
    </>
  )
}
